import React from 'react';

const Body: React.FC = ({ children }) => {
  return <>{children}</>;
};

export default Body;
